export const SMS_VERIFY = 'SMS_VERIFY'
export const SMS_RETRY = 'SMS_RETRY'
export const SMS_SUCCESS = 'SMS_SUCCESS'